import type Big from 'big.js'

import type { EstimateTax } from '$lib/stores/estimate/types'
import type { InvoiceTax } from '$lib/types/client_types'


export enum edited_at {
	Null = 0
	// Null = '',
	// Update = 'upsert',
	// Reset = 'reset'
}

export function getEditedAt() {
	// return Date.now()	
	// return performance.now()	
	return performance.timeOrigin + performance.now()	
}

// === Document ===
export type Document = {
	account_id: string
	archived: boolean
	approved: boolean
	invoiced: boolean
	color: string
	due: string
	heading: string
	id: string
	issued: string
	notes: string
	number: string
	items: DocumentItem[]
	discounts: DocumentDiscount[]
	taxes: DocTax[]
	subtotal: Big
	discount: Big
	tax: Big
	grand_total: Big
	reference: string
	status: string // TODO typify
	terms: string
	last_sent_at: string
	last_viewed_at: string
	last_deleted_at: string
	original_number: string
	currency_id: string
}
export type DocumentPartial = Partial<Document>
 
// === DocumentItem ===
export type DocumentItem = {
	id: string
	item_id: string
	idx: number
	name: string
	details: string
	price: Big
	quantity: Big
	taxes: string[]
	taxable: boolean
	edited_at: edited_at
}

export type CalculatedDocumentItem = DocumentItem & {
	tax: Big,
	tax_totals: DocumentItemTaxTotal
	subtotal: Big
	total: Big
}

export type DocumentItemTaxTotal = {
	[tax_id: string]: Big
}


export type DocTax = InvoiceTax | EstimateTax
export type DocTaxOptions = Partial<DocTax>


export enum TaxType {
	Exclusive = 'exclusive'
}

// === DocumentHistory ===
export type DocumentHistory = {
	id: string
	status: string
	date: string
}


// === DocumentDiscount ===
export type DocumentDiscount = {
	fixed: Big
	id: string
	name: string
	rate: Big
	total: Big
	type: CalculationType
}

// === CalculationType ===
export enum CalculationType {
	Rate = 'rate',
	Fixed = 'fixed'
}

// SERVER Types
export type ServerDocumentItemTaxTotal = {
	[tax_id: string]: string
}
export type ServerDocumentItem = {
	details: string
	id: string
	idx: number
	item_id: string
	name: string
	price: string
	quantity: string
	subtotal: string
	tax: string
	tax_totals: ServerDocumentItemTaxTotal
	taxes: string[]
	taxable: boolean
	total: string
	edited_at: edited_at
}

export const DOC_TYPES = ['estimate', 'invoice', 'expenses', 'pdf2data']